import { useCallback } from "react"
import { Launch } from "@mui/icons-material"
import { track } from "helpers/analytics"
import { TRACKING_EVENTS } from "../constants"

export default function usePopout({ account, summaryKey, summaryInputs, addNotification, localStorageError }) {
  const popout = useCallback(() => {
    const popupTarget = JSON.stringify({ ...summaryInputs, summaryKey })
    const handle = window.open(`/${account}/ai-summary/${summaryKey}`, popupTarget, "popup, width=700, height=800")

    if (!handle) {
      addNotification("error", null, "Please allow pop-ups for this site to view the summary in a new window.")
      return false
    }
    return true
  }, [account, summaryKey, summaryInputs, addNotification])

  const handlePopoutClick = useCallback(() => {
    track(TRACKING_EVENTS.POPOUT, { resource: summaryInputs?.resource })
    return popout()
  }, [popout, summaryInputs])

  const popoutButton = {
    id: "popout",
    title: localStorageError
      ? "The Pop-out feature is disabled due to browser storage limits. Try clearing your browser data."
      : "Pop-out in a new window",
    disabled: localStorageError,
    onClick: handlePopoutClick,
    Icon: Launch,
  }

  return { popout, popoutButton }
}
